import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";
import { paymetSchema } from "../payment";
import { userWithSecretsSchema } from "../user";
import { rateSchema } from "../rate";

export const souscriptionSchema = z.object({
  id: z.string(),
  code: z.string(),
  paymentId: z.string().optional().nullable(),
  userId: z.string(),
  valid_from: z.coerce.date(),
  valid_to: z.coerce.date(),
  is_active: z.boolean(),
  createdAt: z.coerce.date(),
  rateId: z.string().optional().nullable(),
  rate: rateSchema.nullable(),
});

export const souscriptionWithUserSchemaAndPayment = souscriptionSchema.extend({
  user: userWithSecretsSchema,
  payment: paymetSchema.optional(),
});
export class SouscriptionDto extends createZodDto(souscriptionSchema) {}
export class SouscriptionWithUserSchemaAndPaymentDto extends createZodDto(
  souscriptionWithUserSchemaAndPayment,
) {}
export type SouscriptionWithUserSchemaAndPaymentType = z.infer<
  typeof souscriptionWithUserSchemaAndPayment
>;
